import WindowManager from "./WindowManager";

export default WindowManager;
